<template>
  <div class="orderDetails orderNew">
    <div class="order-content">
      <div class="top-btn">
        <!-- <div class="btn1">{{ orderInfo.statusName }}</div> -->
        <div class="info-box">
          <div class="title mb0">订单详情</div>
        </div>
        <div class="flex">
          <div class="btn1 mr20 pointer" v-if="orderInfo.status === 0" @click="handleToPay">支付</div>
          <div class="btn1 mr20 pointer" v-if="moduleType === 'HOTEL' && orderInfo.allowRefund && (orderInfo.status === 6 || orderInfo.status === 20)" @click="handleToRefund">申请退款</div>
          <div class="btn1 mr20 pointer" v-if="moduleType === 'FOOD' && orderInfo.allowRefund && (orderInfo.status === 6 || orderInfo.status === 10 || orderInfo.status === 20)" @click="handleToRefund">申请退款</div>
          <div class="btn1 mr20 pointer" v-if="moduleType === 'FOOD' && orderInfo.status === 28 && !orderInfo.isReviewed" @click="handleToEvaluate">去评价</div>
          <div class="btn1 mr20 pointer" v-if="moduleType === 'FOOD' && orderInfo.status === 28 && orderInfo.isReviewed" @click="handleLookEvalute">查看评价</div>
          <div class="btn2" @click="back">返回我的订单</div>
        </div>
      </div>
      <el-divider class="divider"></el-divider>
      <div v-if="moduleType !== 'RETAIL'" class="info-box">
        <!-- <div class="title">订单信息</div> -->
        <el-row>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">订单编号</span>
              <span class="label-value">{{ orderInfo.orderNo }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">订单状态</span>
              <span class="label-value">{{ orderInfo.statusName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">下单时间</span>
              <span class="label-value">{{ orderInfo.orderTime }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="moduleType !== 'HOTEL'">
            <div class="label-box">
              <span class="label">联系号码</span>
              <span class="label-value">{{ orderInfo.contactMobile }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">订单金额</span>
              <span class="label-value" style="color:#FF4400">¥{{ orderInfo.itemTotal || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">实付金额</span>
              <span class="label-value">¥{{ orderInfo.paymentTotal || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="8" v-if="moduleType === 'HOTEL'">
            <div class="label-box">
              <span class="label">退款金额</span>
              <!-- 退款中的状态 先展示要退款的金额 -->
              <span class="label-value" v-if="orderInfo.status === 30">¥{{ orderInfo.realMoneyOfRefund || 0 }}</span>
              <span class="label-value" v-else>¥{{ orderInfo.refundAmount || 0 }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="moduleType !== 'HOTEL'&&moduleType !== 'PACKAGES'">
            <div class="label-box">
              <span class="label">退款金额</span>
              <span class="label-value" v-if="orderInfo.status === 30">¥{{ orderInfo.realMoneyOfRefund || 0 }}</span>
              <span class="label-value" v-else>¥{{ orderInfo.refundAmount || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="8" v-if="moduleType === 'PACKAGES'&&orderInfo.refundAmount!==null">
            <div class="label-box">
              <span class="label">退款金额</span>
              <span class="label-value" >¥{{ Number(orderInfo.refundAmount || 0).toFixed(2) }}</span>
            </div>
          </el-col>
          <el-col v-if="moduleType !== 'PACKAGES'" :span="8">
            <div class="label-box">
              <span class="label">手续费</span>
              <span class="label-value" v-if="orderInfo.status === 30">¥{{ orderInfo.feeOfRefund || 0 }}</span>
              <span class="label-value" v-else>¥{{ orderInfo.refundFee || 0 }}</span>
            </div>
          </el-col>
          <el-col v-if="moduleType == 'PACKAGES' && orderInfo.refundPoundage!=null" :span="8">
            <div class="label-box">
              <span class="label">手续费</span>
              <span class="label-value">¥{{ Number(orderInfo.refundPoundage || 0).toFixed(2) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="info-box">
        <!-- <div class="title">订单信息</div> -->
        <el-row>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">订单编号</span>
              <span class="label-value">{{ orderInfo.uniteOrderNo }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">下单时间</span>
              <span class="label-value">{{ orderInfo.createdDate }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">订单状态</span>
              <span class="label-value retail-order-status">{{ orderInfo.statusName }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="orderInfo.isDelivery">
          <el-col :span="8">
            <div class="label-box">
              <span class="label">收货人</span>
              <span class="label-value">{{ orderInfo.consignee }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label-box">
              <span class="label">联系电话</span>
              <span class="label-value">{{ orderInfo.phone}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row v-else>
          <!-- <el-col :span="8">
            <div class="label-box">
              <span class="label">取货码</span>
              <span class="label-value">{{ orderInfo.consignee }}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="label-box">
              <span class="label">取货电话</span>
              <span class="label-value">{{ orderInfo.phone}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="label-box">
              <span class="label">收货地址</span>
              <span v-if="orderInfo.defaultDelivery" class="label-value">{{ orderInfo.defaultDelivery.areaName }}{{ orderInfo.defaultDelivery.address }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="moduleType === 'FOOD'" class="mt20">
        <el-table :data="orderInfo.foodCouponList" style="width: 100%">
            <el-table-column align="center" prop="merchIndustryName" label="餐厅名称" />
            <el-table-column align="center" prop="goodsName" label="产品名称" />
            <el-table-column align="center" prop="couponNo" label="券码">
              <template slot-scope="scope">
                <img class="qrcode-red" @click="handleQrcode(scope.row.couponNo)" src="../../assets/imgs/qrcode-red.png" alt="">
              </template>
            </el-table-column>
            <el-table-column align="center" label="有效期至">
              <template slot-scope="scope">
                <span>{{scope.row.validStartDate && scope.row.validEndDate? scope.row.validStartDate + '~' + scope.row.validEndDate : '永久有效'}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="statusName" label="状态" />
        </el-table>
      </div>
      <div v-if="moduleType === 'HOTEL'">
        <el-divider></el-divider>
        <div class="info-box">
          <div class="title">酒店信息</div>
          <el-row>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">酒店名称</span>
                <span class="label-value">{{ orderInfo.merchIndustryName }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">酒店地址</span>
                <span class="label-value">{{ orderInfo.addressDetails }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">联系方式</span>
                <span class="label-value">{{ orderInfo.hotelContactPhone }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <div class="info-box">
          <div class="title">预订信息</div>
          <el-row>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">房型名称</span>
                <span class="label-value">{{ orderInfo.hotelRoomGoods.name}}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">房型信息</span>
                <span class="label-value">
                    <span>{{ orderInfo.roomInfo}}</span>
                </span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">入离时间</span>
                <span class="label-value">{{ orderInfo.useStartDate }} <span class="text-green">—</span> {{ orderInfo.useEndDate }} <span class="text-green"> &nbsp;&nbsp;&nbsp;&nbsp;<span class="text-red">共{{ orderInfo.quantity }}间{{ orderInfo.stayDays }}晚</span></span></span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">入住人</span>
                <span class="label-value">{{ orderInfo.occupants }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">联系方式</span>
                <span class="label-value">{{ orderInfo.contactMobile }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="label-box">
                <span class="label">入住说明</span>
                <span class="label-value">{{ orderInfo.reservationNotes }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-if="moduleType === 'RETAIL'" class="mt20">
        <el-table :data="orderInfo.retailOrderVOList" style="width: 100%">
            <el-table-column align="center" prop="merchIndustryName" label="店铺名称" />
            <el-table-column align="center" prop="goodsName" label="产品名称" />
            <!-- <el-table-column align="center" prop="couponNo" label="产品规格">
              <template slot-scope="scope">
                <img class="qrcode-red" @click="handleQrcode(scope.row.couponNo)" src="../../assets/imgs/qrcode-red.png" alt="">
              </template>
            </el-table-column> -->
            <el-table-column align="center" label="产品单价">
              <template slot-scope="scope">
                <span>￥{{scope.row.unitPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="quantity" label="数量" />
            <el-table-column align="center" label="金额">
              <template slot-scope="scope">
                <span>￥{{scope.row.itemTotal}}</span>
              </template>
            </el-table-column>
        </el-table>
        <div class="sum-info">
          <div class="info-line">商品总额: <span class="value">¥{{orderInfo.itemTotal}}</span></div>
          <div class="info-line">运费: <span class="value">+¥{{orderInfo.freight}} </span></div>
          <div class="info-line">商品优惠: <span class="value">-¥{{orderInfo.coupon || 0}} </span></div>
          <div class="info-line">合计支付: <span class="value sum-amount"><em>¥</em>{{orderInfo.paymentTotal}} </span></div>
        </div>
      </div>
      <!-- 套票 -->
      <div v-if="moduleType === 'PACKAGES'"  class="packageTicket">
        <el-form ref="form" :model="{orderInfo}" label-width="0">
          <div v-for="(subItem, subIdx) in orderInfo.itemList" :key="subIdx" >
            <span class="ticketsort">套票{{subIdx + 1}}</span>
            <div class="visitorMsg">
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#9B232A'}" class="order-table" :default-expand-all="true" :data="subItem.tripList">
                <el-table-column align="center" prop="merchIndustryName" label="景点名称"/>
                <el-table-column align="center" prop="goodsName" label="产品名称"/>
                <el-table-column align="center" label="出游日期">
                <template slot-scope="scope">
                  <span>{{scope.row.useStartDate.split(' ')[0]}}</span>
                </template>
              </el-table-column>

                <el-table-column align="center" label="游客姓名">
                <template slot-scope="scope">
                  <span>{{scope.row.visitorName||'--'}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="证件类型">
                <template slot-scope="scope">
                  <span>{{scope.row.visitorCertificateNo?visitorCertTypeEnum[scope.row.visitorCertificateType]:'--'}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="证件号">
                <template slot-scope="scope">
                  <span>{{scope.row.visitorCertificateNo||'--'}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="票状态">
                <template slot-scope="scope">
                  <span>{{scope.row.ticketStatusName}}</span>
                </template>
              </el-table-column>
              </el-table>
            </div>
            <!-- 酒店 -->
            <div class="visitorMsg">
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#9B232A'}" class="order-table" :default-expand-all="true" :data="subItem.hotelList">
                <el-table-column align="center" label="酒店名称">
                <template slot-scope="scope">
                  <span>{{scope.row.industryName}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="房型名称">
                <template slot-scope="scope">
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="入住时间">
                <template slot-scope="scope">
                  <span>{{scope.row.useStartDate}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="离店时间">
                <template slot-scope="scope">
                  <span>{{scope.row.useEndDate}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="入住者姓名">
                <template slot-scope="scope">
                  <span>{{scope.row.visitorName}}</span>
                </template>
              </el-table-column>
                <el-table-column align="center" label="使用状态">
                <template slot-scope="scope">
                  <span>{{scope.row.used?'已入住':'未入住'}}</span>
                </template>
              </el-table-column>
              </el-table>

            </div>
          </div>
        </el-form>
        <div class="flex-end">
          <div class="btn" v-if="orderInfo.status === 6 || orderInfo.status === 10 || orderInfo.status === 20" @click="handleToRefund">退款</div>
        </div>
      </div>
    </div>
    <!-- 放置二维码的容器,需要给一个ref -->
    <el-dialog
      title="券码"
      :visible.sync="dialogVisible"
      width="15%"
      :append-to-body="true"
      :modal-append-to-body="true"
      class="qrcode-dialog"
    >
      <div class="qrCode">
        <div class="img" id="qrcode"></div>
      </div>
      <p class="couponNo">{{couponNo}}</p>
    </el-dialog>
    <!-- 支付弹框 -->
    <payDialog ref="payDialog" />
    <!-- 退款弹框 -->
    <refundDialog ref="refundDialog" @loadDetail="loadDetail" />
    <!-- 查看评价 -->
    <lookEvaluateDialog ref="lookEvaluateDialog" />
  </div>
</template>

<script>
import { loadDetail, loadBedType } from '@/api/myOrder'
import { getAreaStr } from '@/common/js/utils'
import QRCode from 'qrcodejs2'
import PayDialog from '@/components/payDialog'
import RefundDialog from '@/components/refundDialog'
import LookEvaluateDialog from '@/components/lookEvaluateDialog'
export default {
  name: 'OrderDetail',
  data () {
    return {
      visitorCertTypeEnum: { '0': '',
        '1': '身份证',
        '2': '护照',
        '3': '学生证',
        '4': '军官证',
        '5': '士兵证',
        '6': '驾驶证',
        '7': '回乡证',
        '8': '台胞证',
        '10': '港澳通行证',
        '11': '国际海员证',
        '20': '外国人永久居留证',
        '22': '台湾通行证',
        '23': '儿童无证件',
        '24': '户口薄',
        '25': '出生证明',
        '26': '残疾人证',
        '27': '教师证',
        '99': '其他' },
      moduleType: 'FOOD',
      orderInfo: {
        hotelRoomGoods: {}
      },
      tableData: [],
      orderNo: null,
      bedTypeList: [],
      dialogVisible: false,
      couponNo: null
    }
  },
  created () {
    this.moduleType = this.$route.query.moduleType
    this.mainPic = this.$route.query.mainPic
    this.orderNo = this.$route.query.orderNo
    this.loadBedType()
  },
  components: {
    'payDialog': PayDialog,
    'refundDialog': RefundDialog,
    'lookEvaluateDialog': LookEvaluateDialog
  },
  methods: {
    handleToEvaluate () {
      const info = {
        mainPic: this.orderInfo.mainPic,
        paymentTotal: this.orderInfo.paymentTotal,
        orderNo: this.orderInfo.orderNo,
        merchIndustryId: this.orderInfo.merchIndustryId,
        merchIndustryName: this.orderInfo.merchIndustryName,
        goodsId: this.orderInfo.goodsId,
        goodsName: this.orderInfo.goodsName
      }
      this.$router.push({ path: 'orderEvaluate', query: { info: JSON.stringify(info), moduleType: this.moduleType } })
    },
    handleLookEvalute () {
      this.$refs.lookEvaluateDialog.handleOpenDialog(this.orderInfo)
    },
    handleToPay () {
      if (this.flag) return
      this.flag = true
      this.$refs.payDialog.toPay(this.orderInfo.orderNo, this.orderInfo.orderCat)
    },
    handleToRefund () {
      if (this.moduleType === 'PACKAGES') {
        this.$refs.refundDialog.loadPackagesRefundData(this.orderInfo)
      } else {
        this.$refs.refundDialog.handleShowDialog(this.orderInfo)
      }
    },
    handleQrcode (couponNo) {
      this.couponNo = couponNo
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.dialogVisible) {
          document.getElementById('qrcode').innerHTML = ''
          this.qrcode = new QRCode('qrcode', {
            width: 200,
            height: 200, // 高度
            text: couponNo, // 二维码内容
            render: 'canvas'
            // background: '#f0f',
            // foreground: '#ff0'
          })
        }
      })
    },
    back () {
      this.$router.push({ path: 'orderListNew', query: { moduleType: this.moduleType } })
    },
    loadBedType () {
      loadBedType().then(res => {
        if (res.code === 0) {
          this.bedTypeList = res.data
          this.loadDetail()
        }
      })
    },
    loadDetail () {
      loadDetail(this.orderNo, this.moduleType).then(res => {
        if (res.code === 0 && res.data) {
          const areaStr = getAreaStr(res.data.addressProvinceCode, res.data.addressCityCode, res.data.addressCountyCode)
          res.data.addressDetails = areaStr + res.data.addressDetails
          res.data.itemTotal = Number(res.data.itemTotal).toFixed(2)
          res.data.paymentTotal = Number(res.data.paymentTotal).toFixed(2)
          res.data.realMoneyOfRefund = Number(res.data.realMoneyOfRefund).toFixed(2)
          res.data.feeOfRefund = Number(res.data.feeOfRefund).toFixed(2)
          if (this.moduleType !== 'PACKAGES') {
            res.data.refundAmount = Number(res.data.refundAmount).toFixed(2)
          }
          res.data.refundFee = Number(res.data.refundFee).toFixed(2)
          res.data.mainPic = this.mainPic
          if (this.moduleType === 'HOTEL' && res.data.hotelRoomGoods) {
            const hotelRoomGoods = res.data.hotelRoomGoods
            const bedType = this.bedShapeInformationDeal(hotelRoomGoods.bedShapeInformation)
            res.data.roomInfo = `${bedType}  |  ${hotelRoomGoods.breakfastState} | ${hotelRoomGoods.maximumCapacity}人入住 | ${hotelRoomGoods.usableArea || 0}㎡ | ${hotelRoomGoods.windowsState}`
          }
          if (res.data.tripList && res.data.tripList.length > 0) {
            const tripList = []
            res.data.tripList.forEach(val => {
              val.visitorList.forEach(v => {
                tripList.push({
                  ...val,
                  ...v
                })
              })
            })
            res.data.tripList = tripList
          }
          if (this.moduleType === 'PACKAGES') {
            res.data.itemList.forEach(item => {
              if (item.tripList && item.tripList.length > 0) {
                const tripList = []
                item.tripList.forEach(val => {
                  val.visitorList.forEach(v => {
                    tripList.push({
                      ...val,
                      ...v
                    })
                  })
                })
                item.tripList = tripList
              }
            })
          }
          this.orderInfo = res.data
        }
      })
    },
    // 床型处理
    bedShapeInformationDeal (data) {
      data = JSON.parse(data)
      let bedShapeInformation = ''
      data.forEach(val => {
        const obj = this.bedTypeList.find(v => v.code === val.bedType)
        bedShapeInformation = `${bedShapeInformation},${val.bedNum}张${obj.value}`
      })
      bedShapeInformation = bedShapeInformation.substring(1)
      return bedShapeInformation
    }
  },
  mounted () {
    document.querySelector('body').setAttribute('style', 'background: #F5F6F9;')
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  }
}
</script>
<style>
.qrcode-dialog >div{
  min-width: 400px;
}
</style>
<style lang="scss" scoped>
.orderDetails{
  .mb0{
    margin-bottom: 0 !important;
  }
}
/deep/.qrcode-red{
  width: 24px;
  height: 24px;
}
.qrCode{
  padding-top: 0;
}
.couponNo{
  font-size: 20px;
  text-align: center;
  margin-top: 15px;
}
.sum-info {
  margin-top: 94px;
  text-align: right;
  .info-line {
    margin-bottom: 12px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #424855;
    .value {
      display: inline-block;
      min-width: 120px;
      margin-left: 8px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FF0000;
      text-align: right;
      &.sum-amount {
        font-weight: bold;
        font-size: 28px;
        em {
          margin-right: 5px;
          font-style: normal;
          font-size: 14px;
        }
      }
    }
  }
}
.orderNew .order-content .info-box .label-box .label-value.retail-order-status {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3987E1;
}
.packageTicket{
  .el-table--fit {
    border: 1px solid #333;
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
    .btn {
      margin-top: 20px;
      width: 105px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #9B232A;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.visitorMsg{
  margin-top: 20px;
}
.ticketsort {
  display:inline-block;
  padding: 40px 0 0;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  color: #242B34;
}
</style>
